import { render } from "./TrashedMessage.vue?vue&type=template&id=32ed7db1"
import script from "./TrashedMessage.vue?vue&type=script&lang=js"
export * from "./TrashedMessage.vue?vue&type=script&lang=js"

import exportComponent from "/storage/xmaisdigital/digloja-admin/releases/71/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__